import type { Api } from '@rialtic/api'
export const useCurrentUser = () =>
  useState('current-user', (): Api.AuthUserResponse['data'] | null => null)
